import React from 'react';

import styled from 'styled-components';

import FilterDropdownHeader from 'components/lib/FilterDropdownHeader';

import CompetitorListSection from './CompetitorListSection';
import MyCommunitySection from './MyCommunitySection';
import { useCustomCommunityContractTypeFilterContext } from '../CustomCommunityContractTypeFilterContext';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 360px;
  background-color: white;
  border: 1px solid var(--line-gray);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 14px 18px;
`;

const CustomCommunityContractTypeFilterDropdown = () => {
  const { reset } = useCustomCommunityContractTypeFilterContext();

  return (
    <Container onMouseDown={(event) => event.stopPropagation()} onClick={(event) => event.stopPropagation()}>
      <FilterDropdownHeader onReset={reset} />
      <Body>
        <MyCommunitySection />
        <CompetitorListSection />
      </Body>
    </Container>
  );
};

export default CustomCommunityContractTypeFilterDropdown;
